import script from "./SelectRoom.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectRoom.vue?vue&type=script&setup=true&lang=ts"

import "./SelectRoom.vue?vue&type=style&index=0&id=ca20f9ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca20f9ae"]])

export default __exports__